module.exports = __webpack_public_path__ + "img/icon_file_w.bbbc9bb.png";